import BottomReviewSection from './BottomReviewSection.component';
export default BottomReviewSection;